import { styled } from '@mui/material/styles';
import { Dialog, Stack, Typography, IconButton, Box, Link } from '@mui/material';
import { abyssColors, linkColor } from '@/theme/colors';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    width: 'calc(100vw - 80px)',
    height: 'calc(100vh - 75px)',
    maxWidth: 'none',
    maxHeight: 'none',
    overflow: 'hidden',
  },
  '& .MuiDialog-container': {
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const CopyImageUrl = styled(Link)(() => ({
  fontSize: '1.2rem',
  fontWeight: '600',
  color: linkColor,
  display: 'flex',
  alignItems: 'center',
  gap: '0.550rem',
  cursor: 'pointer',
}));

export const CurrentPoiName = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '14px',
  margin: '0 10px',
}));

export const ImgNavButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: abyssColors.primary[700],
  width: '40px',
  height: '40px',
  zIndex: 2,
}));

export const DialogContentStyle = {
  height: 'calc(100vh - 160px)',
  display: 'flex',
  padding: '20px',
  paddingTop: '0px',
  overflowY: 'auto',
  position: 'relative',
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const PoiNavigationContainer = styled(Stack)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '16px',
});

export const MainContentContainer = styled(Stack)(() => ({
  width: '80%',
  position: 'relative',
  paddingLeft: '80px',
  paddingRight: '20px',
  overflowY: 'auto',
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const MainImageContainer = styled(Box)(() => ({
  width: '96%',
  height: '60vh',
  position: 'relative',
  overflow: 'hidden',
  background: '#000',
}));

export const MainImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  borderRadius: '2px',
}));

export const ZoomControlsContainer = styled(Box)(() => ({
  position: 'absolute',
  bottom: 16,
  right: 16,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
}));

export const ZoomButton = styled(IconButton)(() => ({
  color: abyssColors.neutral[50],
  borderRadius: '5px',
  '&:disabled': {
    color: abyssColors.neutral[300],
  },
}));

export const ImageNumbering = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '1.4rem',
  marginTop: '1.5rem',
  marginBottom: '2.5rem',
  color: abyssColors.primary[700],
}));

export const ThumbnailContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  overflowX: 'auto',
  height: '13.5rem',
  gap: '16px',
  flexWrap: 'nowrap',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const ThumbnailItem = styled(Box)<{ isSelected: boolean }>(({ isSelected }) => ({
  width: '22rem',
  height: '100%',
  flexShrink: 0,
  border: isSelected
    ? `4px solid ${abyssColors.primary[300]}`
    : `2px solid ${abyssColors.primary[200]}`,
  borderRadius: '4px',
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',
  transition: 'border-color 0.2s ease',
}));

export const ThumbnailImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));

export const DetailsContainer = styled(Box)(() => ({
  width: '20%',
  padding: '24px',
  marginTop: '45px !important',
  backgroundColor: abyssColors.primary[100],
  boxSizing: 'border-box',
  maxHeight: 'calc(100vh - 160px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    display: 'none  ',
  },
}));

export const DetailsTitle = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: '500',
  color: abyssColors.primary[500],
  marginBottom: '24px',
}));

export const DetailItemContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  minWidth: 0,
}));

export const DetailLabel = styled(Typography)(() => ({
  color: abyssColors.primary[400],
  fontSize: '12px',
  fontWeight: 500,
  minWidth: 0,
  flexShrink: 1,
  wordBreak: 'break-word',
}));

export const DetailValue = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 500,
  color: abyssColors.primary[500],
  minWidth: 0,
  flexShrink: 1,
  wordBreak: 'break-word',
}));

export const SectionTitle = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: '500',
  color: abyssColors.primary[500],
  margin: '8px 0',
}));

export const BlisterProfileImage = styled('img')(() => ({
  width: '100%',
  height: '135px',
}));

export const ThumbnailMenuWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  zIndex: 2,
}));

export const ThumbnailMenuButton = styled(Box)(() => ({
  background: abyssColors.primary[50],
  border: `1px solid ${abyssColors.primary[200]}`,
  borderRadius: '50%',
  width: 25,
  height: 25,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
